document.addEventListener('DOMContentLoaded', () => {
 // 创建 IntersectionObserver 实例
  window.YGImageLoader = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        const newImg = new Image();
        newImg.onload = () => {
          img.src = newImg.src;
          img.removeAttribute('data-src');  // 如果只需要加载一次
          img.removeAttribute('srcset');
          observer.unobserve(img);          // 停止观察该元素
        }
        newImg.src = img.getAttribute('data-src');
      }
    });
  }, {
    rootMargin: "50px", // 预加载距离视口 50px 的图片
  });

  class YGImage extends HTMLElement {
    constructor() {
      super()
      this.init()
    }

    init() {
      // 这里放置初始化逻辑
      this.loaderImg()
    }

    get images() {
      return this.querySelectorAll('img[data-src]')
    }

    loaderImg() {
      // 这里放置自定义逻辑
      this.images.forEach((img) => {
        window.YGImageLoader.observe(img)
      })
    }
  }

  if (!window.customElements.get('yg-image')) {
    window.customElements.define('yg-image', YGImage)
  }
});